export default __webpack_public_path__ + "809d703f9c913266557a9d4e0ef62703.svg";